export const VERIFY_CONTEXT = "verify-api";

export const VERIFY_SERVER = "https://verify.walletconnect.com";

export const VERIFY_FALLBACK_SERVER = "https://verify.walletconnect.org";

export const TRUSTED_VERIFY_URLS = [VERIFY_SERVER, VERIFY_FALLBACK_SERVER];
